module.exports = __webpack_public_path__ + "img/KGolddiamante.c75ebcaf.png";